<ng-container *ngIf="!loading; else spinner">
    <ng-content></ng-content>
</ng-container>

<ng-template #spinner>
    {{ label }}
    <mat-spinner [diameter]="diameter" />
</ng-template>
